<div class="div1" (click)="$event.stopPropagation()">
  <div class="filter-heading">Sorting</div>
  <div class="ft-sorting d-flex justify-content-between">

    <div (click)="this.sortFilter.emit(this.isActive = !this.isActive)">
      <ul class="" *ngIf="colType == 'numerics' && isActive">
        <li class="ft-sorting1 mb-2">
          <i-feather name="circle"></i-feather>
          {{'Language.Max' | translate}}
        </li>

        <li class="ft-sorting2">
          <mat-icon>arrow_drop_down</mat-icon>
          {{'Language.Min' | translate}}
        </li>
      </ul>
      <ul class="" *ngIf="colType == 'numerics' && !isActive">
        <li class="ft-sorting1 mb-2">
          <i-feather name="circle"></i-feather>
          {{'Language.Min' | translate}}
        </li>
        <li class="ft-sorting2">
          <mat-icon>arrow_drop_down</mat-icon>
          {{'Language.Max' | translate}}
        </li>
      </ul>
      <ul class="" *ngIf="colType == 'alphabets' && isActive">
        <li class="ft-sorting1 mb-2">
          <i-feather name="circle"></i-feather>
          {{'Language.Descending' | translate}}
        </li>
        <li class="ft-sorting2">
          <mat-icon>arrow_drop_down</mat-icon>
          {{'Language.Ascending' | translate}}
        </li>
      </ul>
      <ul class="" *ngIf="colType == 'alphabets' && !isActive">
        <li class="ft-sorting1 mb-2">
          <i-feather name="circle"></i-feather>
          {{'Language.Ascending' | translate}}
        </li>
        <li class="ft-sorting2">
          <mat-icon>arrow_drop_down</mat-icon>
          {{'Language.Descending' | translate}}
        </li>
      </ul>
      <ul class="" *ngIf="colType == 'DateType' && isActive">
        <li class="ft-sorting1 mb-2">
          <i-feather name="circle"></i-feather>
          {{'Language.Newest' | translate}}
        </li>
        <li class="ft-sorting2">
          <mat-icon>arrow_drop_down</mat-icon>
          {{'Language.Oldest' | translate}}
        </li>
      </ul>
      <ul class="" *ngIf="colType == 'DateType' && !isActive">
        <li class="ft-sorting1 mb-2">
          <i-feather name="circle"></i-feather>
          {{'Language.Oldest' | translate}}
        </li>
        <li class="ft-sorting2">
          <mat-icon>arrow_drop_down</mat-icon>
          {{'Language.Newest' | translate}}
        </li>
      </ul>
      <ul class="" *ngIf="colType == 'BoolYN' && isActive">
        <li class="ft-sorting1 mb-2">
          <i-feather name="circle"></i-feather>
          {{'Language.Yes' | translate}}
        </li>
        <li class="ft-sorting2">
          <mat-icon>arrow_drop_down</mat-icon>
          {{'Language.No' | translate}}
        </li>
      </ul>
      <ul class="" *ngIf="colType == 'BoolYN' && !isActive">
        <li class="ft-sorting1 mb-2">
          <i-feather name="circle"></i-feather>
          {{'Language.No' | translate}}
        </li>
        <li class="ft-sorting2">
          <mat-icon>arrow_drop_down</mat-icon>
          {{'Language.Yes' | translate}}
        </li>
      </ul>
    </div>

    <!-- DateType -->
    <!-- {{this.getListViewDataSourceURL}} -->
    <div class="ft-sorting-icon" (click)="this.sortFilter.emit(this.isActive = !this.isActive)">
      <i-feather name="arrow-up" *ngIf="!isActive"></i-feather>
      <i-feather name="arrow-down" *ngIf="isActive"></i-feather>
    </div>
  </div>
</div>
<hr />
<div class="div1" (click)="$event.stopImmediatePropagation()">
  <div class="filter-heading">Filter</div>

  <div [hidden]="colType != 'DateType'">
    <div class="">
      <mat-form-field class="full-width" appearance="outline">
        <input type="text" readonly [(ngModel)]="fromDate" [matDatepicker]="picker" matInput placeholder="From"
          name="fromId" #fromId (keydown.Tab)="$event.stopPropagation();"
          (keydown.shift.Tab)="$event.stopPropagation();">
        <mat-datepicker-toggle matIconSuffix [for]="picker" (keydown.Tab)="$event.stopPropagation();"
          (keydown.shift.Tab)="$event.stopPropagation();"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="">
      <mat-form-field class="full-width" appearance="outline">
        <input type="text" readonly [(ngModel)]="toDate" [matDatepicker]="picker1" matInput placeholder="To" name="toId"
          #toId (keydown.Tab)="$event.stopPropagation();" (keydown.shift.Tab)="$event.stopPropagation();">
        <mat-datepicker-toggle matIconSuffix [for]="picker1" (keydown.Tab)="$event.stopPropagation();"
          (keydown.shift.Tab)="$event.stopPropagation();"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </div>

  </div>

  <div [hidden]="colType == 'DateType'">
    <div class="">
      <mat-form-field class="full-width" appearance="outline">
        <input type="text" matInput placeholder="{{colType == 'numerics' ? 'From' : 'Enter Value'}}"
          name="fromIdDateType" #fromIdDateType (keydown.Tab)="$event.stopPropagation();"
          (keydown.shift.Tab)="$event.stopPropagation();">
      </mat-form-field>
    </div>
    <div class="" [hidden]="colType =='alphabets' || colType =='BoolYN' ">
      <mat-form-field class="full-width" appearance="outline">
        <input type="text" matInput placeholder="To" name="toIdDateType" #toIdDateType
          (keydown.Tab)="$event.stopPropagation();" (keydown.shift.Tab)="$event.stopPropagation();">
      </mat-form-field>
    </div>
  </div>

</div>
<!-- [disabled]="this.fromId.value==''" -->
<div class="ft-actions d-flex justify-content-between div1">
  <button class="me-2 primary-btn" mat-stroked-button color="primary" [hidden]="colType == 'DateType'"
    (click)="this.FilterColumn.emit({column: shortColumn, formid: fromIdDateType.value,toid: toIdDateType.value,label:labelType});fromIdDateType.value='';toIdDateType.value='';">
    {{'Language.DoneText' | translate}}
  </button>
  <button class="me-2 primary-btn" mat-stroked-button color="primary" [hidden]="colType != 'DateType'"
    (click)="this.FilterColumn.emit({column: shortColumn, formid: fromId.value,toid: toId.value,label:labelType});fromId.value='';toId.value='';"
    (click)="clearDate()" (keydown.Tab)="$event.stopPropagation();" (keydown.shift.Tab)="$event.stopPropagation();">
    {{'Language.DoneText' | translate}}
  </button>
  <!-- <button mat-raised-button>
    Reset
  </button> -->
</div>